
jQuery( function() {
    const widget = document.getElementById( 'racehub-widget' );
    if ( !widget ) return;
    window.addEventListener( 'scroll', () => {
        const body = document.body;
        const html = document.documentElement;

        const documentHeight = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );

        if ( window.scrollY > documentHeight - window.innerHeight - 200 ) {
            widget.classList.add( 'hidden' );
        } else {
            widget.classList.remove( 'hidden' );
        }
    }, { passive: true } );
})